import React, { useState } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Text,
    Link,
    useDisclosure,
    useToast,
    FormErrorMessage
} from '@chakra-ui/react'
import RegisterModal from './RegistrationModal'
import ForgotPasswordModal from './ForgotPasswordModal'

const LoginModal = ({ isOpen, onClose, setIsLoggedIn, setUser }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [errors, setErrors] = useState({})
    const toast = useToast()

    const {
        isOpen: isForgotOpen,
        onOpen: onForgotOpen,
        onClose: onForgotClose
    } = useDisclosure()


    const {
        isOpen: isRegisterOpen,
        onOpen: onRegisterOpen,
        onClose: onRegisterClose
    } = useDisclosure()

    const validate = () => {
        const newErrors = {}
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!email || !emailRegex.test(email)) {
            newErrors.email = 'Please enter a valid email address.'
        }

        if (!password) {
            newErrors.password = 'Password is required.'
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async () => {
        if (!validate()) {
            toast({
                title: 'Validation Error.',
                description: 'Please fix the highlighted fields.',
                variant: 'left-accent',
                status: 'error',
                duration: 4000,
                isClosable: true
            })
            return
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    password
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Login failed');
            }

            toast({
                title: 'Login successful.',
                description: `Welcome, ${data.user.name}!`,
                variant: 'left-accent',
                status: 'success',
                duration: 4000,
                isClosable: true
            });
            localStorage.setItem('authToken', data.token)
            localStorage.setItem('authUser', JSON.stringify({
                id: data.user.id,
                name: data.user.name,
                surname: data.user.surname,
                email: data.user.email,
                phone: data.user.phone,
                company: data.user.company,
                optionalEmail: data.user.optionalEmail,
                role: data.user.role
            }));
            setUser(data.user)
            setIsLoggedIn(true)
            onClose();

            window.location.reload();

        } catch (err) {
            toast({
                title: 'Login failed.',
                description: err.message,
                variant: 'left-accent',
                status: 'error',
                duration: 4000,
                isClosable: true
            });
        }
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} isCentered size="md" zIndex={99999}>
                <ModalOverlay />
                <ModalContent p={6} bg="white" containerProps={{ zIndex: '99999' }}>
                    <ModalHeader textAlign="center" fontWeight="bold">Log In</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <Stack spacing={4}>
                            <FormControl id="email" isInvalid={!!errors.email}>
                                <FormLabel>Email address</FormLabel>
                                <Input
                                    type="email"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors.email && <FormErrorMessage>{errors.email}</FormErrorMessage>}
                            </FormControl>

                            <FormControl id="password" isInvalid={!!errors.password}>
                                <FormLabel>Password</FormLabel>
                                <Input
                                    type="password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                {errors.password && <FormErrorMessage>{errors.password}</FormErrorMessage>}
                            </FormControl>

                            <Link color="gray.600" fontSize="sm" textAlign="right" onClick={() => {
                                onClose();
                                onForgotOpen();
                            }}>
                                Forgot password?
                            </Link>
                        </Stack>
                    </ModalBody>

                    <ModalFooter flexDir="column" gap={3}>
                        <Button
                            variant="solid-green-btn"
                            fontWeight={600}
                            onClick={handleSubmit}
                        >
                            Log In
                        </Button>
                        <Text fontSize="sm">
                            Don't have an account?{' '}
                            <Button
                                variant="link"
                                fontWeight="bold"
                                color="black"
                                onClick={() => {
                                    onClose()
                                    onRegisterOpen()
                                }}
                            >
                                Sign Up
                            </Button>
                        </Text>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <RegisterModal isOpen={isRegisterOpen} onClose={onRegisterClose} />
            <ForgotPasswordModal isOpen={isForgotOpen} onClose={onForgotClose} />
        </>
    )
}

export default LoginModal
